import { FC } from "react";
import { Stack } from "@mui/material";
import { useAppSelector } from "@/store/hooks";
import { billingExplorerWidgetTitlePropsSelector } from "@/store/dashboards/selectors/widgets/billing-explorer-widget/widget-view/billingExplorerWidgetTitlePropsSelector";
import { WidgetCardHeader } from "@/components/pages/dashboard/components/widgets/common/widget-header/WidgetCardHeader";
import { WidgetCardHeaderEditButton } from "@/components/pages/dashboard/components/widgets/common/widget-header/components/WidgetCardHeaderEditButton";
import { BillingExplorerWidgetHeaderViewSelect } from "@/components/pages/dashboard/components/widgets/billing-explorer-widget/components/BillingExplorerWidgetHeaderViewSelect";
import {
  WidgetGroupByUpdateThunkType,
  WidgetHeaderGroupBySelect,
} from "@/components/pages/dashboard/components/widgets/common/WidgetHeaderGroupBySelect";
import { BillingExplorerWidgetHeaderDateSelect } from "@/components/pages/dashboard/components/widgets/billing-explorer-widget/components/BillingExplorerWidgetHeaderDateSelect";
import { updateBillingExplorerWidgetFromQuickActionsThunk } from "@/store/dashboards/thunks/widgets/billing-explorer-widget/actions/updateBillingExplorerWidgetFromQuickActionsThunk";

interface BillingExplorerWidgetHeaderProps {
  widgetId: string;
  hovered: boolean;
}

export const BillingExplorerWidgetHeader: FC<
  BillingExplorerWidgetHeaderProps
> = ({ widgetId, hovered }) => {
  const widgetTitleProps = useAppSelector((state) =>
    billingExplorerWidgetTitlePropsSelector(state, widgetId),
  );
  const { sourceData, dates, groupBy, groupValues, groupByLabel } =
    widgetTitleProps ?? {};

  return (
    <WidgetCardHeader
      hovered={hovered}
      widgetId={widgetId}
      widgetType="cost_breakdown"
      widgetTitleProps={widgetTitleProps}
    >
      <Stack spacing={1} direction="row" overflow="hidden">
        <Stack
          direction="row"
          gap={1}
          alignItems="center"
          sx={{ overflowX: "auto", overflowY: "hidden" }}
        >
          {sourceData && (
            <BillingExplorerWidgetHeaderViewSelect
              sourceData={sourceData}
              widgetId={widgetId}
            />
          )}

          <WidgetHeaderGroupBySelect
            widgetId={widgetId}
            groupBy={groupBy}
            groupValues={groupValues}
            groupByLabel={groupByLabel}
            updateThunk={
              updateBillingExplorerWidgetFromQuickActionsThunk as WidgetGroupByUpdateThunkType
            }
          />

          <BillingExplorerWidgetHeaderDateSelect
            widgetId={widgetId}
            dates={dates}
          />
        </Stack>

        <WidgetCardHeaderEditButton
          widgetId={widgetId}
          widgetType="cost_breakdown"
        />
      </Stack>
    </WidgetCardHeader>
  );
};
